import { FeatureAnchor, SampleAnchor, SampleQuote } from "../PaperShared/Sample";

function Sample2020000() {
  return (
    <section className="sample">
      <h4>
        <SampleAnchor modelId="mini" sampleId="2020000" />
        <span> - </span>
        <SampleQuote text="both consciously and" targetIdx={4} targetLength={12} />
      </h4>
      <p>
        This circuit begins with Feature{" "}
        <FeatureAnchor modelId="mini" sampleId="2020000" featureKey="1.0.37" compact /> firing on
        tokens for the word “both”. Downstream, through self-attention, Feature{" "}
        <FeatureAnchor modelId="mini" sampleId="2020000" featureKey="0.2.27" compact /> fires on
        tokens immediately after “both”. In the next layer, Feature{" "}
        <FeatureAnchor modelId="mini" sampleId="2020000" featureKey="0.3.593" compact /> broadens
        its activation to tokens following “both” or “between”. Further along, Feature{" "}
        <FeatureAnchor modelId="mini" sampleId="2020000" featureKey="0.5.1570" compact />{" "}
        specifically activates on the last token before the “and” in a conjunctive phrase. These
        activations, through a chain of dependencies, lead to Feature{" "}
        <FeatureAnchor modelId="mini" sampleId="2020000" featureKey="0.8.1098" compact /> predicting
        that the next token will be “and”.
      </p>
      <figure>
        <figcaption>Detecting the "A and B" Pattern</figcaption>
        <ul className="tree">
          <li>
            <span className="node">
              <span className="feature">
                <FeatureAnchor
                  modelId="mini"
                  sampleId="2020000"
                  featureKey="0.5.1570"
                  compact={true}
                />
              </span>
              <span className="description">
                <SampleQuote
                  text="between a neutral object and"
                  targetIdx={17}
                  targetLength={7}
                  quotes={false}
                  ellipsis={false}
                />
                <SampleQuote
                  text="both the public and"
                  targetIdx={8}
                  targetLength={7}
                  quotes={false}
                  ellipsis={false}
                />
                <SampleQuote
                  text="both libertarianism and"
                  targetIdx={16}
                  targetLength={3}
                  quotes={false}
                  ellipsis={false}
                />
              </span>
            </span>
            <ul>
              <li>
                <span className="node">
                  <span className="feature">
                    <FeatureAnchor
                      modelId="mini"
                      sampleId="2020000"
                      featureKey="0.3.593"
                      compact={true}
                    />
                  </span>
                  <span className="description">
                    <SampleQuote
                      text="between a cloud"
                      targetIdx={7}
                      targetLength={2}
                      quotes={false}
                      ellipsis={false}
                    />
                    <SampleQuote
                      text="between this valley"
                      targetIdx={7}
                      targetLength={5}
                      quotes={false}
                      ellipsis={false}
                    />
                    <SampleQuote
                      text="both the writer"
                      targetIdx={4}
                      targetLength={4}
                      quotes={false}
                      ellipsis={false}
                    />
                    <SampleQuote
                      text="both Proudhon"
                      targetIdx={4}
                      targetLength={5}
                      quotes={false}
                      ellipsis={false}
                    />
                  </span>
                </span>
                <ul>
                  <li>
                    <span className="node">
                      <span className="feature">
                        <FeatureAnchor
                          modelId="mini"
                          sampleId="2020000"
                          featureKey="0.2.27"
                          compact={true}
                        />
                      </span>
                      <span className="description">
                        <SampleQuote
                          text="both primary and"
                          targetIdx={4}
                          targetLength={8}
                          quotes={false}
                          ellipsis={false}
                        />
                        <SampleQuote
                          text="both of the"
                          targetIdx={4}
                          targetLength={3}
                          quotes={false}
                          ellipsis={false}
                        />
                        <SampleQuote
                          text="both types of"
                          targetIdx={4}
                          targetLength={6}
                          quotes={false}
                          ellipsis={false}
                        />
                        <SampleQuote
                          text="both arguments before"
                          targetIdx={4}
                          targetLength={10}
                          quotes={false}
                          ellipsis={false}
                        />
                      </span>
                    </span>
                    <ul>
                      <li>
                        <span className="node">
                          <span className="feature">
                            <FeatureAnchor
                              modelId="mini"
                              sampleId="2020000"
                              featureKey="1.0.37"
                              compact={true}
                            />
                          </span>
                          <span className="description">
                            <SampleQuote
                              text="they both used"
                              targetIdx={4}
                              targetLength={5}
                              quotes={false}
                              ellipsis={false}
                            />
                            <SampleQuote
                              text="enjoyed both from"
                              targetIdx={7}
                              targetLength={5}
                              quotes={false}
                              ellipsis={false}
                            />
                            <SampleQuote
                              text="by both sides"
                              targetIdx={2}
                              targetLength={5}
                              quotes={false}
                              ellipsis={false}
                            />
                            <SampleQuote
                              text="in both female"
                              targetIdx={2}
                              targetLength={5}
                              quotes={false}
                              ellipsis={false}
                            />
                          </span>
                        </span>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </figure>
    </section>
  );
}

export { Sample2020000 };
